query PurchaseOrderInvoiceSchedules($purchaseOrderId: UUID!) {
  purchaseOrderInvoiceSchedules(
    filter: {
      _isSchedule: { equalTo: true }
      purchaseOrderId: { equalTo: $purchaseOrderId }
    }
    orderBy: [INVOICE_SEQUENCE_ASC, SCHEDULED_DATE_ASC]
  ) {
    nodes {
      __typename
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      invoiceSequence
      scheduledDate
      scheduledNote
      scheduledAmount
      invoice {
        invoiceNumber
      }
      purchaseOrderInvoiceScheduleDistributions(
        orderBy: ACCOUNT_REFERENCE_ASC
      ) {
        nodes {
          __typename
          id
          _rowTimestamp
          _createdDate
          _isDeletable
          _isUpdatable
          accountReference
          _accountName
          referenceCode6
          referenceCode7
          scheduledAmount
          productionIncentiveId
          projectReference
          setReference
          tax1099T4TypeId
          referenceCode1
          referenceCode2
          referenceCode3
          referenceCode4
          referenceCode5
        }
      }
    }
    aggregates {
      sum {
        scheduledAmount
      }
    }
  }
}
